module.exports = __webpack_public_path__ + "img/15.ea812804.png";